import React, { memo, useEffect, useState, useRef } from 'react';
import './index.less';
import queryDomMethods from '@/utils/queryDomMethods';

interface GuideStep {
    backgroundImage: string;
    width: number;
    height: number;
    style?: React.CSSProperties;
}

const steps: GuideStep[] = [
    {
        backgroundImage: 'https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202504/08/42591_20250408143523.png',
        width: 740,
        height: 564,
    },

    {
        backgroundImage: 'https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202504/08/cf904_20250408135553.png',
        width: 777,
        height: 392,
        style: {
            marginLeft: -24,
        },
    },
];

const GUIDE_COMPLETED_KEY = 'gd_tiku_predict_score_guide_completed';

const Guide = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [isGuiding, setIsGuiding] = useState<boolean>(false);
    const [styles, setStyles] = useState<React.CSSProperties>();
    const guideSlotsRef = useRef<Element[]>([]);

    // 检查是否已完成引导（跨域检查）
    useEffect(() => {
        const isCompleted = localStorage.getItem(GUIDE_COMPLETED_KEY) || document.cookie.includes(`${GUIDE_COMPLETED_KEY}=true`);
        if (!isCompleted) {
            const firstGuideSlot = queryDomMethods.querySelector('#predict-score-guide');
            if (!firstGuideSlot) {
                console.error('Guide slot element not found');
                return;
            }
            setTimeout(() => {
                firstGuideSlot.scrollIntoView();
                setIsGuiding(true);
            });
        }
    }, []);

    const updateStepStyles = (stepIndex: number) => {
        try {
            // 步骤索引越界保护
            if (stepIndex < 0 || stepIndex >= steps.length) {
                throw new Error('Invalid step index');
            }

            const guideSlot = guideSlotsRef.current[stepIndex];
            if (!guideSlot) {
                throw new Error('Guide slot element not found');
            }

            // 滚动到指定的引导槽位
            guideSlot.scrollIntoView();

            const { top, left } = guideSlot.getBoundingClientRect();
            const step = steps[stepIndex];

            setStyles({
                backgroundImage: `url(${step.backgroundImage})`,
                width: step.width,
                height: step.height,
                top,
                left,
                ...(step.style || {}),
            });
        } catch (err) {
            console.error('Guide error:', err);
            setIsGuiding(false);
        }
    };

    // 点击下一步事件
    const handleClickStep = () => {
        try {
            const nextStep = currentStep + 1;
            if (nextStep < steps.length) {
                setCurrentStep(nextStep);
            } else {
                // 设置主域级别的完成标记
                localStorage.setItem(GUIDE_COMPLETED_KEY, 'true');
                // 同时设置cookie确保跨子域可用
                document.cookie = `${GUIDE_COMPLETED_KEY}=true;domain=.gaodun.com;path=/;max-age=${31536000 * 5}`; // 5年有效期
                setIsGuiding(false);
            }
        } catch (err) {
            console.error('Step navigation error:', err);
            setIsGuiding(false);
        }
    };

    // 初始化以及每一步更新后的效果
    useEffect(() => {
        if (!isGuiding) return;

        try {
            const guideSlots = queryDomMethods.querySelectorAll('#predict-score-guide');
            if (!guideSlots || guideSlots.length === 0) {
                throw new Error('No guide slots found');
            }

            guideSlotsRef.current = Array.from(guideSlots);
            updateStepStyles(currentStep);
        } catch (err) {
            console.error('Initialization error:', err);
            setIsGuiding(false);
        }
    }, [currentStep, isGuiding]);

    if (!isGuiding) return null;

    return (
        <div>
            <div className="sub-tiku__predict-score-guide-mask" onClick={handleClickStep}></div>
            <div className="sub-tiku__predict-score-guide-wrap" onClick={handleClickStep}>
                <div className="sub-tiku__predict-score-guide-content" style={styles}>
                    <button className="sub-tiku__predict-score-guide-button" onClick={handleClickStep}></button>
                </div>
            </div>
        </div>
    );
};

export default memo(Guide);
